import React from 'react'

const FormInput = ({ input, label, type, placeholder, direction, loading, meta: { touched, error, warning } }) => {
  if (direction === 'vertical') {
    return (
      <div className={(touched && error) ? 'has-error' : ''}>
        <label className='control-label'>{label}</label>
        <input className='form-control' {...input} placeholder={placeholder} type={type} disabled={loading} />
        {touched && (error && <span className='help-block'>{error}</span>)}
      </div>
    )
  } else {
    return (
      <div className={(touched && error) ? 'has-error' : ''}>
        <label className='col-sm-2 control-label'>{label}</label>
        <div className='col-sm-9'>
          <input className='form-control' {...input} placeholder={placeholder} type={type} disabled={loading} />
          {touched && (error && <span className='help-block'>{error}</span>)}
        </div>
      </div>
    )
  }
}

export default FormInput



// WEBPACK FOOTER //
// ./src/components/FormInput.js